module.exports = __webpack_public_path__ + "static/media/Пекло-en.d3195355.png";